<template>
  <div class="grid gap-x-6 gap-y-10 max-w-full relative">
    <LayoutSection
      v-for="(section, i) in sections"
      :key="i"
      :type="section.type"
      :items="section.items"
      :section-index="i"
    />
  </div>
</template>

<script lang="ts" setup>
import type { Slice } from './types'
import { buildLayout } from './build-layout'
import LayoutSection from './layout-section.vue'

const props = defineProps<{ slices: Slice[] }>()

const sections = computed(() => {
  return buildLayout(props.slices)
})
</script>
